import { APICallV3Post } from 'reactApp/api/APICall';

export class PdfAttachInfoAPICall extends APICallV3Post {
    _method = '/ovidius/pdf/file/parts';
    _responseType = 'arraybuffer' as const;
    _withCredentials = true;
    _headers = { 'Content-Type': 'application/octet-stream' };
}
